// extracted by mini-css-extract-plugin
export default {"orderSummary":"OrderSummary_orderSummary__eGlh6","summaryRow":"OrderSummary_summaryRow__DHT62"};